var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 9.1665H6.66659M8.33325 12.4998H6.66659M13.3333 5.83317H6.66659M16.6666 5.6665V14.3332C16.6666 15.7333 16.6666 16.4334 16.3941 16.9681C16.1544 17.4386 15.772 17.821 15.3016 18.0607C14.7668 18.3332 14.0667 18.3332 12.6666 18.3332H7.33325C5.93312 18.3332 5.23306 18.3332 4.69828 18.0607C4.22787 17.821 3.84542 17.4386 3.60574 16.9681C3.33325 16.4334 3.33325 15.7333 3.33325 14.3332V5.6665C3.33325 4.26637 3.33325 3.56631 3.60574 3.03153C3.84542 2.56112 4.22787 2.17867 4.69828 1.93899C5.23306 1.6665 5.93312 1.6665 7.33325 1.6665H12.6666C14.0667 1.6665 14.7668 1.6665 15.3016 1.93899C15.772 2.17867 16.1544 2.56112 16.3941 3.03153C16.6666 3.56631 16.6666 4.26637 16.6666 5.6665Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.f66844d2c885515cc59dc09bd982dd1c.svg";
export { ForwardRef as ReactComponent };